import React, { useState } from "react";
import MideaViewer from "./../../midea_viewer/MideaViewer";
// css comes in create_hw_finle.css
import axios from "./../../axios";
import { iconData } from "./../../iconData";
import { Player } from "video-react";
import { IP } from "./../../internalServer";
import PdfViewer from "./PdfViewer";

const CrossAttachmentAssessment = ({
  nextQuestion,
  attachment,
  isEditable,
  setQuestions,
  isReasonForAnswer,
  question,
  componentType
}) => {
  const [mideaviewer, setMideaviewer] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);

  const checkQuestionIDAndDeleteAttachment = async () => {
    if (question?.id) {
      await handleSoftDeleteAttachment();
    } else {
      await handleRemoveAttachment();
    }
  };

  const handleSoftDeleteAttachment = async () => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
        (answer, i) =>
          i === 0
            ? {
              ...answer,
              reason_for_answer: {
                ...answer.reason_for_answer,
                attachment: null,
              },
            }
            : answer
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
        is_question_edited: true,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;
      return newQuestions;
    });
  };
  const handleRemoveAttachment = async () => {
    try {
      let res = await axios.delete(`/api/v1/file/delete`, {
        data: { file_path: attachment },
      });

      res && isReasonForAnswer
        ? setQuestions((prev) => {
          const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
            (answer, i) =>
              i === 0
                ? {
                  ...answer,
                  reason_for_answer: {
                    ...answer.reason_for_answer,
                    attachment: null,
                  },
                }
                : answer
          );

          const updatedQuestion = {
            ...prev[nextQuestion],
            correct_answers: updatedCorrectAnswer,
            is_question_edited: true,
          };

          const newQuestions = [...prev];
          newQuestions[nextQuestion] = updatedQuestion;
          return newQuestions;
        })
        : setQuestions((prev) => {
          const updatedQuestion = {
            ...prev[nextQuestion],
            attachments: prev[nextQuestion].attachments.filter(
              (i) => i !== attachment
            ),
          };
          const newQuestion = [...prev];
          newQuestion[nextQuestion] = updatedQuestion;
          return newQuestion;
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  const getFileExtension = (file) => {
    if (!file) return "";
    return file.match(/\.([^.]+)$/)?.[1]?.toLowerCase() || "";
  };

  const fileExtension = getFileExtension(attachment);

  const isImageOrVideo = [
    "jpg",
    "jpeg",
    "png",
    "mp4",
    "JPG",
    "JPEG",
    "PNG",
    "mp4",
    "MP4",
  ].includes(fileExtension);

  const fileIcon =
    iconData?.find((i) => i.extension === fileExtension)?.icon || "";

  return (
    <>
      <div className="hw_defult_attach_box ml-3">
        <div
          className="d-flex align-items-center"
          onClick={() => {
            const fileType = attachment?.split(".").pop();
            if (
              fileType === "jpg" ||
              fileType === "jpeg" ||
              fileType === "png" ||
              fileType === "mp4" ||
              fileType === "JPG" ||
              fileType === "JPEG" ||
              fileType === "PNG" ||
              fileType === "MP4"
            ) {
              handleClick(attachment);
            } else if (
              fileType === "pdf" ||
              fileType === "PDF" ||
              fileType === "doc" ||
              fileType === "docx"
            ) {
              handleClickforpdf(attachment);
            }
          }}
        >
          {
            <div className="d-flex align-items-center">
              {isImageOrVideo ? (
                <div
                  onClick={() => {
                    if (!isError) handleClick(attachment);
                  }}
                  className="ContainerUploadedPdf d-flex gap-2 p-1"
                >
                  <div className="d-flex align-items-center pdf_logo">
                    <img
                      src={fileIcon}
                      alt="attachment icon"
                      className="mr-2 hw_defult_attach_type_icon"
                    />
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex align-items-center pdf_logo"
                  onClick={() => handleClickforpdf(attachment)}
                >
                  <img
                    src={fileIcon}
                    alt="attachment icon"
                    className="mr-2 hw_defult_attach_type_icon"
                  />
                </div>
              )}
            </div>
          }
          {/* <img
              className="mr-2 hw_defult_attach_type_icon"
              src={`/images/${attachment?.match(/\.([^.]+)$/)[1]}.svg`}
              src={`${
                iconData?.find(
                  (i) => i.extension === attachment?.match(/\.([^.]+)$/)[1]
                )?.icon
              }`}
              alt="icon"
            /> */}
          <div className="hw_default_attach_name">
            <span>{attachment?.replace(/^[^_]*_/, "")}</span>
          </div>
        </div>
        {isEditable && (
          <img
            onClick={() => checkQuestionIDAndDeleteAttachment()}
            className="attachment_cross_icon"
            src="/images/attachment_cross_icon.png"
            alt="icon"
          />
        )}
      </div>
      {mideaviewer && (
        <PdfViewer
          setMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
          responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    onClick={() => {
                      handleClick();
                      setIsError(false);
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo-1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
              {/* <img
                className="imgMain"
                src={IP + responseAttach?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div> */}
            </div>
          </div>
        ))}
    </>
  );
};

export default CrossAttachmentAssessment;
